import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  loading: boolean;
}

export const SubmitButton: FC<Props> = ({ loading }) => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <RightAlign>
      <Button
        type="submit"
        loading={loading}
        data-trackid={getTrackId(
          'submit-signing-right',
          TrackingElement.Button,
        )}
      >
        {texts.orders.signatureRight.goToSigning}
      </Button>
    </RightAlign>
  );
};

const RightAlign = styled.div`
  display: flex;
  justify-content: flex-end;
`;
